import months from "./months.json";
import days from "./days.json";

export default { months, days };
